import { cn } from '@/lib/utils';
import { ChatParticipant } from '@my-ipractice/types';
import { useState } from 'react';

type Props = {
  participant: ChatParticipant;
  large?: boolean;
};

export const ChatParticipantProfilePicture = ({ participant, large }: Props) => {
  const [hasImageError, setHasImageError] = useState(false);

  return (
    <>
      {participant.image && !hasImageError ? (
        <img
          src={participant.image}
          className={cn(
            'min-w-12 min-h-12 w-12 h-12 rounded-lg object-cover',
            large && 'min-w-64 min-h-64 w-64 h-64'
          )}
          onError={() => setHasImageError(true)}
        />
      ) : (
        <div
          className={cn(
            'min-w-12 min-h-12 w-12 h-12 rounded-lg bg-secondary flex items-center justify-center',
            large && 'min-w-64 min-h-64 w-64 h-64'
          )}
        >
          <p className={cn('text-accent text-xl', large && 'text-6xl')}>
            {participant.name.charAt(0)}
          </p>
        </div>
      )}
    </>
  );
};
